import React, { useCallback } from "react"
import { Marker } from "@googlemaps/markerclusterer"
import { AdvancedMarker } from "@vis.gl/react-google-maps"
import { Point } from "../Map"

export type ShopMarkerProps = {
  shop: Point
  onClick: (shop: Point) => void
  setMarkerRef: (marker: Marker | null, key: string) => void
}

export default function ShopMarker({ shop, onClick, setMarkerRef }: ShopMarkerProps) {
  const handleClick = useCallback(() => onClick(shop), [onClick, shop])
  const ref = useCallback(
    (marker: google.maps.marker.AdvancedMarkerElement) => {
      setMarkerRef(marker, shop.id)
    },
    [setMarkerRef, shop.id],
  )
  return (
    <AdvancedMarker
      key={shop.id}
      position={{ lat: shop.lat, lng: shop.lng }}
      onClick={handleClick}
      ref={ref}
    >
      <img src="/images/mainOffice.svg" alt="mainOffice" />
    </AdvancedMarker>
  )
}
